export const KB = 1024
export const MB = 1024 * KB

const ImageMimes = ['image/jpeg','image/jpg','image/pjpeg','image/png','image/x-png', 'image/gif','image/tiff','image/bmp','image/svg+xml','image/webp','image/x-icon']
const DocMimes = [
    'text/plain',
    'application/rtf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
    'application/vnd.ms-word.document.macroEnabled.12',
    'application/vnd.ms-word.template.macroEnabled.12',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
    'application/vnd.ms-excel.sheet.macroEnabled.12',
    'application/vnd.ms-excel.template.macroEnabled.12',
    'application/vnd.ms-excel.addin.macroEnabled.12',
    'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/vnd.openxmlformats-officedocument.presentationml.template',
    'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
    'application/vnd.ms-powerpoint.addin.macroEnabled.12',
    'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
    'application/vnd.ms-powerpoint.slideshow.macroEnabled.12',
    'application/vnd.ms-powerpoint',
    'application/vnd.mspowerpoint',
    'application/x-gzip',
    'application/zip',
    'application/rar',
    "application/x-tar",
    'application/pdf',
    'application/kswps',
    'application/kset',
    'application/ksdps',
    'application/x-photoshop',
    'application/x-coreldraw',
    'application/x-shockwave-flash',
]

function formatSize(sizeInBytes) {
    if (sizeInBytes === 0) return '0 B';

    let k = 1024
    let sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    let i = Math.floor(Math.log(sizeInBytes) / Math.log(k));

    return (sizeInBytes / Math.pow(k, i)).toPrecision(3) + ' ' + sizes[i];
}

function validateUploadImage(file, maxFileSize) {
    const isSizeOk = file.size < maxFileSize;
    if (!isSizeOk) {
        return {ok: false, msg: '上传图片大小不能超过' + formatSize(maxFileSize) + "!"}
    }
    let isImageOk = ImageMimes.includes(file.type)
    if (!isImageOk) {
        return {ok: false, msg: '上传图片只能是BMP/JPG/PNG/GIF/TIF/SVG/WEBP格式!'}
    }
    return {ok: true, msg: ""}
}

function validateUploadDoc(file, maxFileSize) {
    const isSizeOk = file.size < maxFileSize;
    if (!isSizeOk) {
        return {ok: false, msg: '上传文件大小不能超过' + formatSize(maxFileSize) + "!"}
    }
    let isDocOk = DocMimes.includes(file.type)
    if (!isDocOk) {
        return {ok: false, msg: '上传文件只能是TXT/RTF/WORD/EXCEL/PPT/PDF/ZIP/RAR/TAR/WPS/ET/DPS/PSD/CDR/SWF格式!'}
    }
    return {ok: true, msg: ""}
}

function validateUploadAvatar(file) {
    return validateUploadImage(file, 500*KB)
}


export default {
    validateUploadAvatar,
    validateUploadLogo : file => validateUploadImage(file, 500*KB),
    validateUploadIdCard : file => validateUploadImage(file, 3*MB),
    validateUploadCarousel : file => validateUploadImage(file, 2*MB),
    validateUploadImage,
    validateUploadDoc,
}
